export default __webpack_public_path__ + "static/media/marker.ec7f42fe.png";